import React, { Component } from "react";
import styled from "styled-components";
import CountUp from "react-countup";
class StatTable extends Component {
  render() {
    const {
      colCount,
      data // [{ label: head, value: body, unit }, { label: head, value: body, unit }, { label: head, value: body, unit }]
    } = this.props;
    return (
      <TableStyle colCount={colCount}>
        <colgroup>
          {[...Array(colCount)].map((_, idx) => (
            <col key={idx} />
          ))}
        </colgroup>
        <thead>
          <tr>
            {data.map(({ label }, idx) => (
              <th key={idx}>{label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {data.map(({ value, unit }, idx) => (
              <td key={idx}>
                {
                  typeof value === "number" ? (
                    <CountUp end={value} />
                  ) : (
                    value
                  )
                }
                {unit ? ` ${unit}` : ""}</td>
            ))}
          </tr>
        </tbody>
      </TableStyle>
    )
  }
}

const TableStyle = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  th, td {
    font-size: 14px;
    font-weight: 500;
    color: #F1F3F5
    border-bottom: 1px solid #dce0e3;
    border-top: 1px solid #dce0e3;
  }
  th {
    background: #f1f3f5;
    color: #484848;
  }
  td {
    text-align: center;
    color: #8a8a8a;
    border-bottom: 1px solid #dce0e3;
    border-top: 1px solid #dce0e3;
    padding: 5px 0;
  }
  colgroup {
    col {
      width: ${({ colCount }) => 100 / colCount}%;
    }
  }
`;


export default StatTable;